import React, {useEffect} from "react";
import SignInSection from "../components/SignInSection";
import { useAuth } from "util/auth.js";
import { oauthRequest } from "util/api/util";
import { useLocation } from "util/router";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function SigninSSOPage(props) {

  const auth = useAuth();

  const client_id = useQuery().get('client_id')
  const redirect_uri = useQuery().get('redirect_uri')
  const response_type = useQuery().get('response_type')

  useEffect(() => {
    if (!auth?.userData || !auth.userData.isInstructor) {
      return
    }
    console.log("EFFECT")

    oauthRequest(`authorize?client_id=${client_id}&redirect_uri=${redirect_uri}&response_type=${response_type}`)
      .then(data => {
        console.log("RESPONSE FROM OAUTH: ", data)
        window.location.assign(data.redirect)
      })
      .catch(err => {
        console.log("ERROR FROM OAUTH: ", err)
      })


  }, [auth.userData?.platformID])

  

  return (
    <SignInSection
      afterAuthUrl={""}
      disableAfterAuth={true}
      bg="white"
      textColor="dark"
      size="md"
      bgImage=""
      bgImageOpacity={1}
      title="Connect to Sutra"
      subtitle=""
      buttonText="Sign in"
      inputSize="lg"
    ></SignInSection>
  );
}

export default SigninSSOPage;
